import React from "react";
import PropTypes from "prop-types";
import { NodeOrMultipleNodes } from "../../../../../components/utility/Aux";

/**
 * RowRenderer: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Renderer for spreadsheet rows; also displays a leading
 * cell containg the row number
 *
 * @param {*} props
 */
const RowRenderer = props => (
  <tr>
    <td className="cell read-only">{props.row + 1}</td>
    {props.children}
  </tr>
);

RowRenderer.propTypes = {
  row: PropTypes.number.isRequired,
  children: NodeOrMultipleNodes.isRequired
};

export default RowRenderer;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/spreadsheet/RowRenderer.js